// ========================================
// 📄 src/components/dashboard/ConversionChart.jsx (VERSION AMÉLIORÉE)
// ========================================
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

const ConversionChart = ({ data }) => {
  const chartData = [
    { name: "Nouveau", count: data.nouveau || 0, color: "#3b82f6" },
    { name: "Contacté", count: data.contacte || 0, color: "#8b5cf6" },
    { name: "Qualifié", count: data.qualifie || 0, color: "#06b6d4" },
    { name: "Négociation", count: data.negociation || 0, color: "#f59e0b" },
    { name: "Converti", count: data.converti || 0, color: "#10b981" },
    { name: "Perdu", count: data.perdu || 0, color: "#ef4444" },
  ];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="panel-quiet p-3">
          <p className="font-semibold text-[var(--color-text-primary)]">
            {label}
          </p>
          <p className="text-sm text-[var(--color-text-secondary)]">
            <span className="font-semibold text-[var(--color-brand)]">
              {payload[0].value}
            </span>{" "}
            prospects
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-semibold text-[var(--color-text-primary)]">
          Entonnoir de conversion
        </h3>
        <div className="flex items-center gap-2 text-sm text-[var(--color-text-muted)]">
          <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
          <span>Prospects par étape</span>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={350}>
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="rgba(148,163,184,0.18)"
          />
          <XAxis
            dataKey="name"
            tick={{ fontSize: 12, fill: "#94a3b8" }}
            axisLine={{ stroke: "rgba(148,163,184,0.24)" }}
          />
          <YAxis
            tick={{ fontSize: 12, fill: "#94a3b8" }}
            axisLine={{ stroke: "rgba(148,163,184,0.24)" }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="count" name="Nombre de prospects" radius={[4, 4, 0, 0]}>
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      {/* Statistiques additionnelles */}
      <div className="mt-6 grid grid-cols-2 gap-4">
        <div className="panel-quiet p-4">
          <p className="text-sm text-[var(--color-text-muted)] mb-1">
            Taux de conversion global
          </p>
          <p className="text-2xl font-semibold text-emerald-600">
            {data.conversionRate || 0}%
          </p>
        </div>
        <div className="panel-quiet p-4">
          <p className="text-sm text-[var(--color-text-muted)] mb-1">
            Total prospects
          </p>
          <p className="text-2xl font-semibold text-[var(--color-brand)]">
            {data.total || 0}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConversionChart;
